<template>
  <el-dialog
    width="572px"
    top="15vh"
    class="invoice-dialog"
    :visible.sync="dialogVisible"
    :lock-scroll="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :onClose="handleClose">
    <span slot="title" class="invoice-dialog__title">
      {{ dialogTitle }}
      <baseTipPopover placement="right" :content="titleTips" />
    </span>
    <div>
      <el-form size="small" ref="invoiceForm" label-width="130px" label-position="right" :model="form"
        :rules="rules[form.invoiceType]">
        <!--  发票类型  -->
        <el-form-item label="发票类型：" prop="invoiceType">
          <base-radio-group v-model="form.invoiceType" @change="handleInvtypeChange">
            <el-radio-button :label="1" border>数电增值税(专用)发票</el-radio-button>
            <el-radio-button :label="2" border>数电增值税(普通)发票</el-radio-button>
          </base-radio-group>
        </el-form-item>

        <!--  普票 start  -->
        <div v-if="form.invoiceType == 2">
          <el-form-item key="type" label="抬头类型：" prop="type">
            <base-radio-group v-model="form.type">
              <el-radio-button :label="1" border>公司</el-radio-button>
              <el-radio-button :label="2" border>个人</el-radio-button>
            </base-radio-group>
          </el-form-item>

          <el-form-item key="invoiceTitle_2" label="发票抬头：" prop="invoiceTitle">
            <BaseInput v-model="form.invoiceTitle" placeholder="请输入发票抬头" width="341px"></BaseInput>
          </el-form-item>

          <!--  抬头类型：公司  -->
          <div v-if="form.type == 1">
            <el-form-item key="taxCode_2" label="纳税人识别号：" prop="taxCode">
              <BaseInput v-model="form.taxCode" placeholder="8、10、15、17、18、20位数字或字母组合" width="341px"></BaseInput>
            </el-form-item>

            <el-form-item key="taxAddr_2" label="地址：" prop="taxAddr">
              <BaseInput v-model="form.taxAddr" placeholder="请输入地址" width="341px"></BaseInput>
            </el-form-item>

            <el-form-item key="taxTel_2" label="电话：" prop="taxTel">
              <BaseInput v-model="form.taxTel" placeholder="请输入电话" width="341px"></BaseInput>
            </el-form-item>

            <el-form-item key="taxBank_2" label="开户行：" prop="taxBank">
              <BaseInput v-model="form.taxBank" placeholder="请输入开户行" width="341px"></BaseInput>
            </el-form-item>

            <el-form-item key="taxBankAccount_2" label="银行账号：" prop="taxBankAccount">
              <BaseInput v-model="form.taxBankAccount" placeholder="请输入银行账号" width="341px"></BaseInput>
            </el-form-item>
          </div>
          <span v-else></span>
        </div>
        <!--  普票 end  -->

        <!--  增票 start  -->
        <div v-if="form.invoiceType == 1">
          <div class="invoice-tips" v-if="shouldShowTips">
            {{ tips }}
          </div>
          <el-form-item key="invoiceTitle_1" label="发票抬头：" prop="invoiceTitle">
            <BaseInput v-model="form.invoiceTitle" placeholder="请输入发票抬头" width="341px"></BaseInput>
          </el-form-item>

          <el-form-item key="taxCode_1" label="纳税人识别号：" prop="taxCode">
            <BaseInput v-model="form.taxCode" placeholder="8、10、15、17、18、20位数字或字母组合" width="341px"></BaseInput>
          </el-form-item>

          <el-form-item key="taxAddr_1" label="地址：" prop="taxAddr">
            <BaseInput v-model="form.taxAddr" placeholder="请输入地址" width="341px"></BaseInput>
          </el-form-item>

          <el-form-item key="taxTel_1" label="电话：" prop="taxTel">
            <BaseInput v-model="form.taxTel" placeholder="请输入电话" width="341px"></BaseInput>
          </el-form-item>

          <el-form-item key="taxBank_1" label="开户行：" prop="taxBank">
            <BaseInput v-model="form.taxBank" placeholder="请输入开户行" width="341px"></BaseInput>
          </el-form-item>

          <el-form-item key="taxBankAccount_1" label="银行账号：" prop="taxBankAccount">
            <BaseInput v-model="form.taxBankAccount" placeholder="请输入银行账号" width="341px"></BaseInput>
          </el-form-item>
        </div>
        <!--  增票 end  -->

        <el-form-item>
          <BaseButton size="small" :round="false" :loading="saveLoading" @click="handleSubmit">{{ buttonText }}
          </BaseButton>
        </el-form-item>
      </el-form>
        <el-dialog top="32vh" v-if="shouldShowTips && showConfirm" :visible.sync="showConfirm" destroy-on-close  append-to-body title="提示" width="480px">
          <div style="margin: -9px 4px 0;">
            您正在添加的这张专用发票需经财务审核，审批通过后可使用于订单，请确认是否提交？
          </div>
          <template #footer>
            <BaseButton size="small" :round="false" type="default" @click="showConfirm = false">取消
            </BaseButton>
            <BaseButton size="small" :round="false" :loading="saveLoading" @click="handler">确认
            </BaseButton>
          </template>
        </el-dialog>
    </div>
  </el-dialog>
</template>
<script>
import { addInvoice, updateInvoice, getUserInvoiceNum } from '@@/api/customer'

export default {
  name: 'editInvoice',
  props: {
    // 发票类型：1 增票, 2 普票
    invoiceType: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    const DEFAULT_DATA = Object.freeze({
      1: {
        invoiceType: 1, // 发票类型：1 增值税发票, 2 普通发票
        taxCode: '', // 纳税人识别号
        taxAddr: '', //　地址
        taxTel: '', // 电话
        taxBank: '', // 开户银行
        taxBankAccount: '', // 开户银行账号
        invoiceTitle: '', // 普通发票：发票抬头， 增值税发票：单位名称
        type: 1, // 抬头类型(增值税发票默认传1)
      },
      2: {
        invoiceType: 2, // 发票类型：1 增值税发票, 2 普通发票
        taxCode: '', // 纳税人识别号
        taxAddr: '', //　地址
        taxTel: '', // 电话
        taxBank: '', // 开户银行
        taxBankAccount: '', // 开户银行账号
        invoiceTitle: '', // 普通发票：发票抬头， 增值税发票：单位名称
        type: 1, // 抬头类型
      },
    })

    return {
      dialogVisible: false,
      saveLoading: false,
      type: 'add', // add 新增， edit 编辑
      defaultData: DEFAULT_DATA,
      form: { ...DEFAULT_DATA[this.invoiceType] },
      rules: {
        // 增值税发票
        1: {
          invoiceTitle: [
            { required: true, message: '请填写发票抬头', trigger: 'blur' },
            { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' },
          ],
          taxCode: [
            // 税号由8、10、15、17、18、20位数字或字母组合
            { required: true, message: '请填写纳税人识别号', trigger: 'blur' },
            { pattern: /^([A-Za-z0-9]{15}|[A-Za-z0-9]{20}|[A-Za-z0-9]{17,18}|[A-Z]{1}[0-9]{9}|[0-9]{8})$/, message: '8、10、15、17、18、20位数字或字母组合' },
          ],
          taxAddr: [
            { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' },
          ],
          taxTel: [
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
          ],
          taxBank: [
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
          ],
          taxBankAccount: [
            { pattern: /^\d{6,30}$/, message: '请输入正确的银行卡账号' },
          ],
        },
        // 普通发票
        2: {
          type: [{ required: true, message: '请选择抬头类型', trigger: 'blur' }],
          invoiceTitle: [
            { required: true, message: '请填写发票抬头', trigger: 'blur' },
            { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' },
          ],
          taxCode: [
            // 税号由8、10、15、17、18、20位数字或字母组合
            { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
            { pattern: /^([A-Z0-9]{15}|[A-Z0-9]{20}|[A-Z0-9]{17,18}|[A-Z]{1}[0-9]{9}|[0-9]{8})$/, message: '8、10、15、17、18、20位数字或字母组合' },
          ],
          taxAddr: [{ required: false, min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }],
          taxTel: [{ required: false, min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }],
          taxBank: [{ required: false, min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
          taxBankAccount: [{ required: false, pattern: /^\d{6,30}$/, message: '请输入正确的银行卡账号' }],
        },
      },
      titleTips: `开票温馨提示：
          1. 开具类型： 普通发票与专用发票，均使用数电发票开具。
          2. 开票金额： 以实际支付金额为准，优惠券、现金券、运费券、及积分抵扣等部分不含在内。
          3. 申请时机： 订单发货后即可申请开票。
          4. 获取方式： 发票将发送至您的邮箱，您也可在“用户中心/发票管理”中或通过客户经理获取。
          5. 其他问题：如有疑问请联系您的客户经理。`,
      shouldShowTips: false,
      showConfirm: false
    }
  },
  computed: {
    dialogTitle() {
      return `${this.type === 'edit' ? '编辑' : '新增'}发票信息`
    },
    buttonText() {
      return this.type === 'edit' ? '保存' : '提交'
    },
    tips() {
      return this.type === 'edit' ? '请注意：您正在修改的这张专用发票信息保存后需提交财务审核。在审核期间，该发票将暂时无法使用。审核通过后即可恢复使用。' : '请注意：您正在添加的这张专用发票需经财务审核，无法立即用于本订单，保存后待审核通过即可使用。'
    }
  },
  methods: {
    open(item) {
      const { invoiceType, defaultData } = this
      this.type = item ? 'edit' : 'add'
      this.$set(this, 'form', { ...defaultData[invoiceType], ...(item || {}) })
      this.shouldShowTips = false
      getUserInvoiceNum().then(res => {
        this.shouldShowTips = res.body && res.body.isAccountPeriod === 1 && res.body.invoiceNum > 0
      })
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    // 关闭弹框
    handleClose() {
      this.resetForm()
      this.dialogVisible = false
    },

    resetForm() {
      this.$nextTick(() => {
        this.form = {}
        // this.$refs.form.resetFields()
      })
    },

    // 发票类型改变时，重置表单数据
    handleInvtypeChange(val) {
      const { defaultData, form } = this
      this.$set(this, 'form', { ...defaultData[val], ...form })
    },
    handler() {
      this.saveLoading = true
      const ApiEdit = this.type === 'edit' ? updateInvoice : addInvoice
      ApiEdit(this.form)
        .then((res) => {
          const { body, suc, msg } = res
          if (suc) {
            this.$emit('success', this.form.invoiceType, body.id || this.form.id)
            this.dialogVisible = false
            this.showConfirm = false
            this.resetForm()
          } else {
            this.$message.error(msg)
          }
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    // 提交
    handleSubmit() {
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          if (this.form.type == 2) {
            this.form.taxCode = ''
          }
          if (this.shouldShowTips && this.form.invoiceType == 1) {
            this.showConfirm = true
          } else {
            this.handler()
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.invoice-dialog {
  .invoice-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
  }

  .invoice-tips {
    margin: 0 0 20px 130px;
    border: 1px dashed #f4ded4;
    background-color: #fef5e4;
    padding: 7px 10.5px;
    color: #c08534;
    border-radius: 3px;
    width: 341px;
    box-sizing: border-box;
    font-size: 12px;
  }
}
</style>